<template>
  <div class="selection-repeater">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'product-details-data',

  data() {
    return {
      impressions: [],
    };
  },
};
</script>
